module.exports = __webpack_public_path__ + "media/yao.041a899d.mp4";